/* src/components/library-item-filters-selected-button/library-item-filters-selected-button.component.scss */
:host {
  display: inline-block;
  vertical-align: top;
}
:host:empty {
  display: none;
}
.filter-button {
  margin: 0 var(--vwui-size-spacing-base) var(--vwui-size-spacing-base) 0;
  white-space: nowrap;
}
.filter-button__content {
  color: var(--vwui-color-dark);
}
.filter-button__pdf-content {
  margin: 0.2rem;
}
.filter-button__icon {
  --vwui-icon--size: 0.7em;
  display: inline-block;
  vertical-align: top;
  margin: 0.35em calc(var(--vwui-size-spacing-xxs) * -1) 0 var(--vwui-size-spacing-base);
}
/*# sourceMappingURL=library-item-filters-selected-button.component-XN3DHOLA.css.map */
